import React from "react";

function AllGamesTiming({ name, number, adContent }) {
  return (
    <div>
      <div className=" m-2">
        <div className="w-full  border-dashed rounded-3xl bg-yellow-300 border-4 p-2 text-xl border-blue-600 text-center">
          {adContent && (
            <div dangerouslySetInnerHTML={{ __html: adContent }} />
          )}

          <div className="h-20 flex justify-center items-center">
            <div>
              <a
                className="hover:blue-800"
                target="_blank"
                href={`https://wa.me/${number}`}
                id="body_contactwa"
              >
                <strong> 👉https://wa.me/{number} </strong>
              </a>
            </div>
          </div>
          <div className=" h-20 flex justify-center items-center ">
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/${number}`}
              id="body_contactwa"
            >
              <strong>
                <img
                  className="rounded-full h-16 w-16 object-cover"
                  loading="lazy"
                  src={require("./logo.png")}
                  alt="Whatsapp to show game on this website"
                />
              </strong>
            </a>
          </div>

          <p className="text-sm">
            NOTE: &nbsp; इस नंबर पर लीक गेम नही मिलता गेम लेने वाले भाई कॉल या
            मैसेज न करें।
          </p>
        </div>
      </div>
    </div>
  );
}

export default AllGamesTiming;
